export { default } from './locations';
